(ns kyber.kyber-db.activity-director-report)

(defn ->ident-key
  [{activity-uuid :activity/uuid
    external-user-id :external-user/id}]
  (str "activity-" activity-uuid "_external-user-" external-user-id "-director-report"))

(def model
  {:ident-key ->ident-key})
